// Donation amount configuration — adapted from Magic Forest
// EU compliance limits
export const DONATION_LIMITS = {
  MIN_AMOUNT: 1,
  MAX_AMOUNT: 99,
};

// Quick selection amounts
export const PREDEFINED_AMOUNTS = [10, 25, 50, 99];

// All supported amounts (€1–€99)
export const ALL_SUPPORTED_AMOUNTS = Array.from({ length: 99 }, (_, i) => i + 1);

// Active subscription amounts
export const ACTIVE_SUBSCRIPTION_AMOUNTS = ALL_SUPPORTED_AMOUNTS;

export const isValidAmount = (amount) => {
  const num = parseInt(amount, 10);
  return num >= DONATION_LIMITS.MIN_AMOUNT && num <= DONATION_LIMITS.MAX_AMOUNT;
};

export const hasActiveSubscription = (amount) => {
  return ACTIVE_SUBSCRIPTION_AMOUNTS.includes(parseInt(amount, 10));
};

export const getAmountValidationError = (amount) => {
  const num = parseInt(amount, 10);
  if (isNaN(num) || num < DONATION_LIMITS.MIN_AMOUNT) {
    return `Minimum donation amount is €${DONATION_LIMITS.MIN_AMOUNT}`;
  }
  if (num > DONATION_LIMITS.MAX_AMOUNT) {
    return `Maximum donation amount is €${DONATION_LIMITS.MAX_AMOUNT} (EU law compliance)`;
  }
  return null;
};

export const getSubscriptionAvailabilityMessage = (amount, donationType) => {
  if (donationType !== 'monthly') return null;
  const num = parseInt(amount, 10);
  if (!hasActiveSubscription(num)) {
    const activeAmountsText = ACTIVE_SUBSCRIPTION_AMOUNTS.map(a => `€${a}`).join(', ');
    return `Monthly subscriptions currently available for: ${activeAmountsText}`;
  }
  return null;
};
